<!-- order-table.component.html -->
<div class="table-responsive">
  <h2>Rechnungsübersicht</h2>
  <table mat-table [dataSource]="receipts" class="mat-elevation-z8">
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="tableNumber">
      <th mat-header-cell *matHeaderCellDef>Tischnummer</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.tableNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="orderNo">
      <th mat-header-cell *matHeaderCellDef>Rechnungsnummer</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.orderNo }}</td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Summe</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.total | currency: 'EUR': 'symbol' }}</td>
    </ng-container>

    <ng-container matColumnDef="waiterName">
      <th mat-header-cell *matHeaderCellDef>Kellner</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.waiterName }}</td>
    </ng-container>

    <ng-container matColumnDef="comments">
      <th mat-header-cell *matHeaderCellDef>Kommentar</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.comments }}</td>
    </ng-container>

    <ng-container matColumnDef="printReceipt">
      <th mat-header-cell *matHeaderCellDef>Rechnung drucken</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.printReceipt | yesNo }}</td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef>Erstellt von</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.createdBy }}</td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Erstellt am</th>
      <td mat-cell *matCellDef="let receipt">{{ receipt.created }}</td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let receipt">
        <button mat-icon-button (click)="showOrderDetails(receipt.positions)">
          <mat-icon>info</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="printAgain">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let receipt">
        <button mat-icon-button (click)="printReceiptAgain(receipt)">
          <mat-icon>print</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let receipt; columns: displayedColumns;"></tr>
  </table>
</div>
